import { Component } from '@angular/core';
import { BotaoAcoesType } from '../layout/botao-acoes/botao-acoes';
import { TabContainerOptionType } from '../layout/tab-container/tab-container';

@Component({
    template: ''
})
export abstract class ActionContainer {
    isEditTab: boolean = false;

    abstract getActions(): { [ind: string]: BotaoAcoesType & { useEdit: boolean } };
    abstract setAction(actionIndex: string, action: BotaoAcoesType & { useEdit: boolean }): void;

    abstract getOptions(): TabContainerOptionType[];
    abstract setOption(opt: TabContainerOptionType, tabIndex: number): void;

    setTabActions(tab: string, action: BotaoAcoesType & { useEdit: boolean }) {
        this.setAction(tab, action);
        this.buildTabActions(tab);
        this.setIsEditTab(tab);
    }

    buildTabActions(tab: string): void {
        const options = this.getOptions();
        const tabOptionIndex = options.findIndex((opt) => opt.value === tab);
        this.updateSelectedOptionActionByIndex(tabOptionIndex, tab);
    }

    setIsEditTab(tab: string) {
        const actions = this.getActions();
        this.isEditTab = actions[tab]?.useEdit ?? false;
    }

    updateSelectedOptionActionByIndex(tabIndex: number, tab: string): void {
        const options = this.getOptions();
        let selectedOption = options[tabIndex];
        selectedOption = this.overrideActionForTab(selectedOption, tab);

        this.setOption(selectedOption, tabIndex);
    }

    getTabActions(tab: string) {
        return this.getActions()[tab]?.items ?? [];
    }

    overrideActionForTab(selectedOption: TabContainerOptionType, tab: string): TabContainerOptionType {
        return {
            ...selectedOption,
            actions: {
                items: [...this.getTabActions(tab)]
            }
        };
    }
}
